import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#ff5722',
    secondary: '#4caf50',
    accent: '#009688', // teal
    error: '#f44336', // red
    warning: '#ffc107',
    info: '#2196f3',
    success: '#4CAF50', // green
  },
  customProperties: true,
  iconfont: 'mdi',
})
